import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import container from '../../helpers/container'
import config from '../../config'
import {
  ContainerDivs,
  LinkIcon,
  GetStartedInput,
  VideoModal
} from '../../components'
import Styles from './VideoTutorials.css'

@CSSModules(Styles)
export default class VideoTutorials extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Video tutorials'
    const description = 'Watch our video tutorials to learn how to get your money out of fossil fuels.'
    const url = config.domain + config.routes.videoTutorials

    const thumbs = [
      [
        '492212055',
        require( '../../../static/images/video-thumbnail-1-introduction.png' ),
        'An introduction',
        'Learn the basics of our sites, with a focus on Fossil Free Funds. We\'ll show you how to find your fund holdings and grades, use search filters, and more.',
      ],
      [
        '519720867',
        require( '../../../static/images/video-thumbnail-2-finding-fund.png' ),
        'Finding my fund',
        'Learn how to find your fund and fund grades.',
      ],
      [
        '520123964',
        require( '../../../static/images/video-thumbnail-3-navigating-sites.png' ),
        'Navigating sites',
        'Learn how to jump between sites to learn the details on why and how each fund grade is assigned across our seven sites.',
      ],
      [
        '520182245',
        require( '../../../static/images/video-thumbnail-4-fund-families.png' ),
        'Fund families',
        'We analyze funds from over a hundred different asset managers. Learn how to find fund families and see an overview of the holdings.',
      ],
      [
        '519712485',
        require( '../../../static/images/video-thumbnail-5-search-filters.png' ),
        'Fund search filters',
        'Learn how to apply different filters during your fund search, so you can find top rated funds according to the issues you care about the most.',
      ],
      [
        '519695062',
        require( '../../../static/images/video-thumbnail-6-comparing-funds.png' ),
        'Comparing funds',
        'Learn how to easily compare funds side by side, and analyze their financial performance, fund grades, and more.',
      ],
    ]

    return (
      <div styleName='page'>
        {container.helmet(title, description, url)}
        <ContainerDivs>

          <h1 styleName='title'>{title}</h1>

          <div styleName='lede'>
            <p>
              Our database exposes unsustainable investments hidden in your
              retirement funds, and helps you find cleaner alternatives. Click
              a video below to learn how to get the most of our tools.
            </p>
          </div>

          <div>
            <Row styleName='video-thumbnail-row'>
              {
                thumbs.map((e,i)=>{
                  return (
                    <Col
                      key={'video-thumbnail-col-'+i}
                      xs={12}
                      sm={12}
                      md={6}
                      styleName='video-thumbnail-col'
                    >
                      <VideoModal vimeoId={thumbs[i][0]}>
                        <Row>
                          <Col xs={12} sm={12} md={6}>
                              <img
                                styleName='video-thumbnail-img'
                                src={thumbs[i][1]}
                                alt={thumbs[i][2]}
                              />
                          </Col>
                          <Col xs={12} sm={12} md={6}>
                            <div styleName='video-thumbnail-summary-wrap'>
                              <p styleName='video-thumbnail-summary'>
                                {thumbs[i][3]}
                              </p>
                              <p styleName='video-thumbnail-play'>
                                Play video<LinkIcon faclass='fa-play'/>
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </VideoModal>
                    </Col>
                  )
                })
              }
            </Row>
          </div>

        </ContainerDivs>

        <GetStartedInput/>
      </div>
    )
  }
}
